import type { JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';

export default component$((): JSX.Element => {
  return (
    <div class='flex lg:mr-4 lg:w-[calc(70%-3em)] max-w-full'>
      <Slot />
    </div>
  );
});
